import '../css/accessdenied.css'

export default function AccessDenied() {
  return (
    <div className="container">
      <div className="card">
        <h1 className="title"><b>Access Denied</b></h1>

        <p className="message">
          You do not have permission to access this application.
        </p>

        <p className="subMessage">
          Please contact your administrator.
        </p>
      </div>
    </div>
  );
}
